"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opalStyle = void 0;
var base_1 = require("./base");
var cardo_1 = require("./cardo");
var inter_1 = require("./inter");
var opalStyle = function (family) {
    if (family === 'Inter') {
        return inter_1.inter;
    }
    if (family === 'Cardo') {
        return cardo_1.cardo;
    }
    return base_1.opalBase;
};
exports.opalStyle = opalStyle;
//# sourceMappingURL=index.js.map